import './App.css';
import { useState,useEffect } from 'react';
import {Routes,Route,Router} from 'react-router-dom';
import Home from './Pages/Home/Home.jsx';
import WeddingPackage from './Pages/packages/WeddingPackage.jsx';
import PackageBooking from './Pages/packages/PackageBooking.jsx';
import  Booking from './Pages/Venues/Booking.jsx';
import Login from './Pages/Auth/Login.jsx';
import Register from './Pages/Auth/Register.jsx';
import Profile from './Pages/Auth/Profile.jsx';

function App() {
  return (
    <div className="App">
      
      <Routes>
        <Route path='/' element={<Home/>}/>
         <Route path='/login' element={<Login/>}/>
         <Route path='/profile' element={<Profile/>}/>
          <Route path='/register' element={<Register/>}/>
        <Route path='/packages' element={<WeddingPackage/>}/>
        <Route path='/booking' element={<Booking/>}/>
        <Route path='/packages/:id' element={<PackageBooking/>}/>
        
      </Routes>
    </div>
  );
}

export default App;
